export default __webpack_public_path__ + "73de8c26a2e308e138bf0f740b6653c0.svg";